import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { ResumeSendModalModule } from '../resume-send-modal/resume-send-modal.module';
import { SwiperEmployerTestimonyModule } from '../core-public/swiper-employer-testimony/swiper-employer-testimony.module';
import { SwiperEmployerBenefitModule } from '../core-public/swiper-employer-benefit/swiper-employer-benefit.module';
import { SwiperEmployerModule } from '../core-public/swiper-employer/swiper-employer.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SwiperHomeHeaderComponent } from './swiper-home-header/swiper-home-header.component';
import { SwiperModule } from 'swiper/angular';
import { SwiperEmployerTestimonyVideoModule } from '../core-public/swiper-employer-testimony-video/swiper-employer-testimony-video.module';
import { SharedModule } from '../shared/shared.module';
import { SwiperHomeInstitutionProComponent } from './swiper-home-institution-pro/swiper-home-institution-pro.component';
import { VideoAsImageModule } from '../core-public/video-as-image/video-as-image.module';
import { JobSearchFormModule } from '../job-search-form/job-search-form.module';
import { SharedSearchModule } from '../shared-search/shared-search.module';
import { BannerMainStatsModule } from '../banner-main-stats/banner-main-stats.module';
import { JobSearchCategoryModule } from '../job-search-category/job-search-category.module';


@NgModule({
  declarations: [
    HomeComponent,
    SwiperHomeHeaderComponent,
    SwiperHomeInstitutionProComponent
  ],
  imports: [
    BannerMainStatsModule,
    SharedSearchModule,
    JobSearchFormModule,
    VideoAsImageModule,
    SharedModule,
    SwiperModule,
    SwiperEmployerTestimonyModule,
    SwiperEmployerBenefitModule,
    SwiperEmployerTestimonyVideoModule,
    SwiperEmployerModule,
    ReactiveFormsModule,
    ResumeSendModalModule,
    CommonModule,
    HomeRoutingModule,
    JobSearchCategoryModule
  ]
})
export class HomeModule { }
